// import TableHeadComponent from "../../../../elements/TableHeadComponent";
import TableHeadComponent from "../../../../elements/TableHeadComponent";

const TableHead = ({ children }) => {
  return <TableHeadComponent>{children}</TableHeadComponent>;
};

export default TableHead;
